<template>
  <BgImageLayout title="Define your custom form">
    <q-card class="bg-white">
      <q-card-section>
        <FormGenerator :form-data="formData" @update="updateForm" @save="saveForm" />
      </q-card-section>
    </q-card>
  </BgImageLayout>
</template>

<script>
import FormGenerator from './components/FormGenerator'
import * as apiTo from '@/modular-api'

export default {
  components: {
    FormGenerator
  },

  props: {
    id: [String, Number] // from route
  },

  data() {
    return {
      formData: null
    }
  },

  created() {
    if (this.id) this.getForm()
    else this.getCreateFromData()
  },

  methods: {
    getForm() {
      apiTo.GET_CUSTOM_FORM(this.id).then(({ data }) => (this.formData = data.result))
    },

    getCreateFromData() {
      apiTo.GET_CUSTOM_FORMS_CREATE().then(({ data }) => (this.formData = data.result))
    },

    saveForm(form) {
      apiTo.CREATE_CUSTOM_FORM(form).then(() => this.$router.push({ name: 'forms' }))
    },

    updateForm(newForm) {
      apiTo.UPDATE_CUSTOM_FORM(newForm.id, newForm)
    }
  }
}
</script>
